
export const experienceMapping = {
  'actieve_vakantie': ['actief', 'avontuur', 'sport', 'wandelen', 'fietsen', 'klimmen'],
  'zonvakantie': ['zon', 'strand', 'zonnig', 'warm', 'zwemmen', 'relaxen'],
  'wintersport': ['wintersport', 'skiën', 'snowboard', 'sneeuw', 'piste'],
  'stedentrip': ['stad', 'stedentrip', 'cultuur', 'museum', 'shopping'],
  'roadtrip': ['roadtrip', 'auto', 'route', 'rondrit', 'autovakantie'],
  'wellness': ['wellness', 'spa', 'ontspanning', 'massage', 'sauna'],
  'romantisch': ['romantisch', 'koppel', 'honeymoon', 'liefde', 'huwelijksreis'],
  'gezin': ['gezin', 'familie', 'kinderen', 'kids', 'family', 'pubers', 'jeugd', 'tieners', 'teenagers', 'jongeren'],
  'all_inclusive': ['all inclusive', 'alles inbegrepen', 'ai'],
  'cruise': ['cruise', 'cruisen', 'schip', 'boot'],
  'rondreis': ['rondreis', 'rondreizen', 'tour', 'groepsreis'],
  'adults_only': ['adults only', 'volwassenen', '18+', 'geen kinderen', 'rustig', 'stil']
};

export const detectExperienceType = (searchTerms: string[]): string | null => {
  for (const [type, keywords] of Object.entries(experienceMapping)) {
    if (keywords.some(keyword => searchTerms.includes(keyword))) {
      console.log('Detected experience type:', type);
      return type;
    }
  }
  return null;
};
